import React, { useMemo } from "react";
import styled from "@emotion/styled";
import Shared01Buttons from "../../Shared01Buttons/Shared01Buttons";
import Shared03Divider from "../../Shared03Divider/Shared03Divider";
import { buildCssGF } from "../../../guesappfuction/guestappfuction";

const VALID_TAGS = ["h1", "h2", "h3", "h4", "h5", "h6", "p", "span"];

const validateHtmlTag = (tag) =>
  VALID_TAGS.includes(tag?.toLowerCase()) ? tag : "span";

const ContainerSection = styled.section`
  ${({ css }) => `
    ${css.containerMobile}

    .main-heading {
      ${css.mainHeadingMobile}
    }

    .support-heading {
      ${css.supportHeadingMobile}
    }

    .paragraph {
      ${css.paragraphMobile}
    }

    @media (min-width: ${css.breakpoint}px) {
      ${css.containerDesk}

      .main-heading {
        ${css.mainHeadingDesk}
      }
      .support-heading {
        ${css.supportHeadingDesk}
      }
      .paragraph {
        ${css.paragraphDesk}
      }
    }     
  `}
`;

const sanitizeHtml = (html = "") =>
  html.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "");

const Heading01 = ({ options = {} }) => {
  const {
    section_id,
    style_render = 992,
    main_container_css = "",
    container_mobile_styles = {},
    container_desktop_styles = {},
    obj_heading = {},
    obj_support_heading = {},
    obj_divider = {},
    obj_paragraph = {},
    obj_buttons = {},
  } = options;

  const { main_objinfo, secundary_objinfo, btn_main_container_classes } =
    obj_buttons;

  const MainHeadingTag = validateHtmlTag(obj_heading.main_tag_version);
  const SupportHeadingTag = validateHtmlTag(
    obj_support_heading.main_tag_version
  );
  const ParagraphTag = validateHtmlTag(obj_paragraph.main_tag_version);

  const compiledStyles = useMemo(
    () => ({
      breakpoint: Number(style_render),

      //Container
      containerMobile: buildCssGF(container_mobile_styles),
      containerDesk: buildCssGF(container_desktop_styles),

      //Headings
      mainHeadingMobile: buildCssGF(obj_heading.heading_mobile_styles),
      mainHeadingDesk: buildCssGF(obj_heading.heading_desktop_styles),
      supportHeadingMobile: buildCssGF(
        obj_support_heading.heading_mobile_styles
      ),
      supportHeadingDesk: buildCssGF(
        obj_support_heading.heading_desktop_styles
      ),

      //Paragraph
      paragraphMobile: buildCssGF(obj_paragraph.paragraph_mobile_styles),
      paragraphDesk: buildCssGF(obj_paragraph.paragraph_desktop_styles),
    }),
    [
      style_render,
      container_mobile_styles,
      container_desktop_styles,
      obj_heading,
      obj_support_heading,
      obj_paragraph,
    ]
  );

  return (
    <ContainerSection
      {...(section_id && { id: section_id })}
      className={`c-heading ${main_container_css}`}
      css={compiledStyles}
    >
      <MainHeadingTag
        {...(obj_heading?.text_id && { id: obj_heading?.text_id })}
        className={`main-heading ${obj_heading.main_text_css || ""}`}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(obj_heading.main_text),
        }}
      />

      {obj_support_heading && (
        <SupportHeadingTag
          {...(obj_support_heading?.text_id && {
            id: obj_support_heading?.text_id,
          })}
          className={`support-heading ${
            obj_support_heading.main_text_css || ""
          }`}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(obj_support_heading.main_text),
          }}
        />
      )}

      {obj_divider && (
        <Shared03Divider options={{ obj_divider, style_render }} />
      )}

      {obj_paragraph && (
        <ParagraphTag
          {...(obj_paragraph?.text_id && {
            id: obj_paragraph?.text_id,
          })}
          className={`paragraph ${obj_paragraph.main_text_css || ""}`}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(obj_paragraph.main_text),
          }}
        />
      )}

      {main_objinfo && (
        <Shared01Buttons
          options={{
            main_objinfo,
            secundary_objinfo,
            btn_main_container_classes,
          }}
        />
      )}
    </ContainerSection>
  );
};

export default Heading01;
